import React from 'react';

import SpinnerIcon from '../../assets/images/spinner.svg';

const COMMIT_PATTERN = /^[0-9a-f]{40}$/i;

export const deployChangelogPath = ({ previousBuild, build }) => {
  const params = new URLSearchParams({ from: previousBuild.commit, to: build.commit });
  return `/staff/deploy-changelog?${params.toString()}`;
};

export const canShowDeployChangelog = ({ isStaff, previousBuild, build }) =>
  Boolean(
    isStaff &&
      COMMIT_PATTERN.test(previousBuild?.commit || '') &&
      COMMIT_PATTERN.test(build?.commit || '') &&
      previousBuild.commit !== build.commit,
  );

export const shouldAutoReloadForUpdate = ({ reason, isChangelogOpen, visibilityState }) =>
  reason === 'restart' && !isChangelogOpen && visibilityState === 'hidden';

export const DeployChangelogContent = ({ state, previousBuild, build }) => {
  if (state.status === 'loading') {
    return (
      <div className="flex flex-1 items-center justify-center gap-2 py-12 text-sm text-gray-500 dark:text-neutral-400">
        <SpinnerIcon className="size-4 animate-spin" />
        <span>Loading from GitHub.</span>
      </div>
    );
  }

  if (state.status === 'error') {
    return (
      <div className="rounded-xl bg-white p-4 text-sm text-gray-600 dark:bg-neutral-900 dark:text-neutral-300">
        The changelog is unavailable right now. You can still close this window and apply the update.
      </div>
    );
  }

  const changes = state.changelog?.changes || [];
  if (changes.length === 0) {
    return (
      <div className="rounded-xl bg-white p-4 text-sm text-gray-600 dark:bg-neutral-900 dark:text-neutral-300">
        No code changes were found for this restart.
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2">
      <p className="mb-2 text-xs text-gray-500 dark:text-neutral-400">
        {changes.length} {changes.length === 1 ? 'change' : 'changes'} between {previousBuild.commit.slice(0, 8)} and{' '}
        {build.commit.slice(0, 8)}
      </p>
      {changes.map((change) => (
        <a
          key={`${change.kind}:${change.number || change.commit}`}
          href={change.url}
          target="_blank"
          rel="noreferrer"
          className="block cursor-pointer rounded-xl bg-white px-4 py-3 hover:bg-gray-50 dark:bg-neutral-900 dark:hover:bg-neutral-800"
        >
          <span className="block text-sm font-medium text-black dark:text-neutral-100">{change.title}</span>
          <span className="mt-1 block font-mono text-2xs text-gray-500 dark:text-neutral-400">
            {change.kind === 'pull_request' ? `PR #${change.number}` : `Commit ${change.commit.slice(0, 8)}`}
          </span>
        </a>
      ))}
      {state.changelog?.truncated ? (
        <p className="pt-2 text-xs text-gray-500 dark:text-neutral-400">Showing the 100 most recent mainline changes.</p>
      ) : null}
    </div>
  );
};
